export default "/assets/images/hw-carbon.png?f11d65a2e0d6abff641df4b36b8d1e15";